<template>
  <Accordion
    v-if="newslettersAvailable && !singleNewsletter"
    :activeIndex="activeTab"
    @tab-open="changeNewsletterQuery($event, route)"
    @tab-close="deleteHashParam('nl_newsletterid')"
  >
    <AccordionTab v-for="newsletter in activeNewsletters" :key="newsletter.id" :header="newsletter.name">
      <NewsletterDetail
        :newsletter="newsletter"
        :privacyPageUri="privacyPageUri"
        :verificationMessage="newsletter.id === verificationMessage.id ? verificationMessage.message : null"
      />
    </AccordionTab>
  </Accordion>

  <NewsletterDetail
    v-if="newslettersAvailable && singleNewsletter"
    :newsletter="singleNewsletter"
    :privacyPageUri="privacyPageUri"
    :verificationMessage="singleNewsletter.id === verificationMessage.id ? verificationMessage.message : null"
  />

  <template v-if="!newslettersAvailable">Keine Newsletter gefunden</template>
</template>

<script>
import { newsletterStore } from '@/store/newsletter-store';
import { domainStore } from '@/store/domain-store';
import { onBeforeMount, ref, onMounted, computed, watch } from 'vue';
// import Accordion from "primevue/accordion";
// import AccordionTab from "primevue/accordiontab";
import NewsletterDetail from '@/components/newsletter/NewsletterDetail.vue';
import { useRoute } from 'vue-router';
import useHashParams from '@/composables/general/useHashParams';
import useAuthentication from '@/composables/user/useAuthentication';

export default {
  name: 'Newsletter',
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    newsletterid: {
      type: Number,
      required: false,
    },
    privacyPageUri: {
      type: String,
      required: false,
    },
    lang: {
      type: String,
      required: false,
      default: 'de',
    },
  },

  setup(props) {
    onBeforeMount(() => {
      domainStore.initDomain(props.domainid, props.lang);
    });

    const { initStorageAuthToken } = useAuthentication();

    //vars
    const route = useRoute();
    const { deleteHashParam } = useHashParams(route);
    const activeTab = ref();
    const verificationMessage = ref({ id: null, message: null });

    //methods
    const changeNewsletterQuery = (activeTab, route) => {
      newsletterStore.changeNewsletterQuery(activeTab.index, route);
    };

    //computed
    const singleNewsletter = computed(() => {
      return newsletterStore.getState().singleNewsletter;
    });
    const activeNewsletters = computed(() => {
      return newsletterStore.getState().newsletters;
    });
    const newslettersAvailable = computed(() => {
      if (singleNewsletter.value) {
        return true;
      }
      if (activeNewsletters.value) {
        return activeNewsletters.value.length > 0;
      }
      return false;
    });

    //lifehooks
    onMounted(() => {
      if (props.newsletterid) {
        newsletterStore.getSingleNewsletter(props.newsletterid);
        return;
      }
      newsletterStore.getNewsletters().then(() => {
        activeTab.value = newsletterStore.getActiveTab(Number(route.query.nl_newsletterid));
      });
    });
    watch(route, () => {
      if (route.query.nl_newsletterid) {
        newsletterStore.getActiveTab(Number(route.query.nl_newsletterid));

        if (route.query.nl_unsubscribetoken) {
          newsletterStore
            .unsubscribe(Number(route.query.nl_newsletterid), route.query.nl_unsubscribetoken)
            .then(response => {
              verificationMessage.value = {
                id: Number(route.query.nl_newsletterid),
                message: response,
              };
            })
            .catch(error => {
              verificationMessage.value = {
                id: Number(route.query.nl_newsletterid),
                message: error,
              };
            });
          deleteHashParam('nl_unsubscribetoken');
        }
        if (route.query.nl_verifytoken) {
          newsletterStore
            .verifyToken(Number(route.query.nl_newsletterid), route.query.nl_verifytoken)
            .then(response => {
              verificationMessage.value = {
                id: Number(route.query.nl_newsletterid),
                message: response,
              };
            })
            .catch(error => {
              console.error(error);
              verificationMessage.value = {
                id: Number(route.query.nl_newsletterid),
                message: error,
              };
            });
          deleteHashParam('nl_verifytoken');
        }
      }
    });
    return {
      activeNewsletters,
      singleNewsletter,
      activeTab,
      changeNewsletterQuery,
      route,
      deleteHashParam,
      newslettersAvailable,
      verificationMessage,
    };
  },

  components: {
    NewsletterDetail,
  },
};
</script>

<style scoped></style>
